<form
  class="form w-100"
  novalidate="novalidate"
  [formGroup]="forgotPasswordForm"
  (ngSubmit)="submit()"
  id="kt_login_password_reset_form"
>
  <div
    class="text-center mb-6 h-250px d-flex flex-column align-items-center justify-content-center pt-8 px-12"
  >
    <h2 class="text-gray-800 fw-semibold mb-1">กรุณากรอกที่อยู่อีเมลของท่าน</h2>
    <h2 class="text-gray-800 fw-semibold mb-3">
      เพื่อใช้ในการยืนยันตัวตนและรีเซ็ทรหัสผ่าน
    </h2>
    <div
      class="d-flex flex-column w-100 min-h-200px align-items-center justify-content-center"
    >
      <div class="col-12 text-start mb-8">
        <label class="form-label fs-6 fw-normal text-gray-800 mb-1">
          {{ "AUTH.EMAIL" | translate }}</label
        >
        <input
          class="form-control bg-transparent"
          type="email"
          name="email"
          placeholder="user-email@hotmail.com"
          formControlName="email"
          autocomplete="off"
        />
      </div>

      <div class="d-flex flex-column justify-content-start col-12 gap-2">
        <button
          class="btn btn-icon btn-primary w-auto p-1 px-4"
          data-testid="reset-request"
          (click)="resetRequest()"
          [disabled]="forgotPasswordForm.invalid"
        >
          <!-- See user-password: `loading` is a spinner, and a button that
               spins before it is pressed reads as stuck. -->
          <app-keenicon
            name="sms"
            class="fs-1 svg svg-icon me-2"
          ></app-keenicon>
          ส่งคำขอรีเซ็ทรหัสผ่าน
        </button>
      </div>
    </div>
  </div>

  <!-- @if (errorState === errorStates.HasError) {
  <div class="mb-lg-15 alert alert-danger">
    <div class="alert-text font-weight-bold">
      Sorry, looks like there are some errors detected, please try again.
    </div>
  </div>
  } @if (errorState === errorStates.NoError) {
  <div class="mb-10 bg-light-info p-8 rounded">
    <div class="text-info">Sent password reset. Please check your email</div>
  </div>
  }

  <div class="fv-row mb-8">
    <label class="form-label fw-bolder text-gray-900 fs-6">{{ "AUTH.EMAIL" | translate }}</label>
    <input
      class="form-control bg-transparent"
      type="email"
      formControlName="email"
      [attr.placeholder]="'AUTH.EMAIL' | translate"
      name="email"
      autocomplete="off"
      [ngClass]="{
        'is-invalid': forgotPasswordForm.controls['email'].invalid,
        'is-valid': forgotPasswordForm.controls['email'].valid
      }"
    />

    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Email is required',
        control: forgotPasswordForm.controls['email']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'email',
        message: 'Email is invalid',
        control: forgotPasswordForm.controls['email']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'minLength',
        message: 'Email should have at least 3 symbols',
        control: forgotPasswordForm.controls['email']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Email should have maximum 360 symbols',
        control: forgotPasswordForm.controls['email']
      }"
    ></ng-container>
  </div>
  <div class="d-flex flex-wrap justify-content-center pb-lg-0">
    <button
      type="submit"
      data-testid="forgot-submit"
      id="kt_password_reset_submit"
      class="btn btn-primary me-4"
    >
      <span class="indicator-label">Submit</span>
      @if (isLoading$ | async) {
      <span class="indicator-progress">
        Please wait...
        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
      </span>
      }
    </button>
    <a
      id="kt_login_password_reset_form_cancel_button"
      class="btn btn-light"
      (click)="updateAuthState(AuthStates.UNAUTHORIZED)"
    >
      Cancel
    </a>
  </div> -->
</form>
<!--end::Form-->

<ng-template
  #formError
  let-control="control"
  let-message="message"
  let-validation="validation"
>
  @if (control.hasError(validation) && (control.dirty || control.touched)) {
  <div class="fv-plugins-message-container">
    <div class="fv-help-block">
      <span role="alert">{{ message }}</span>
    </div>
  </div>
  }
</ng-template>
